"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcPdf_1 = require("./AcPdf");
var AcDocumentViewer = function (props) {
    var pdfSource = props.pdfSource, multiPage = props.multiPage, faxId = props.faxId, faxDocumentType = props.faxDocumentType, showRotation = props.showRotation, faxDocument = props.faxDocument, enablePdfAction = props.enablePdfAction, editing = props.editing, _a = props.handleShowEditor, handleShowEditor = _a === void 0 ? function () { } : _a, _b = props.handleCancel, handleCancel = _b === void 0 ? function () { } : _b, fabricDataMapJSON = props.fabricDataMapJSON, onCreateDraft = props.onCreateDraft, validateInCharge = props.validateInCharge, updateInCharge = props.updateInCharge;
    var pdfjs = require('react-pdf').pdfjs;
    // use jsdelivr instead of static.aperza.com (to avoid maintaining 23), plus jsdelivr has more cdn's
    var pdfJsRootPath = "https://cdn.jsdelivr.net/npm/pdfjs-dist@" + pdfjs.version;
    pdfjs.GlobalWorkerOptions.workerSrc = pdfJsRootPath + "/build/pdf.worker.min.js";
    var documentOptions = {
        cMapUrl: pdfJsRootPath + "/cmaps/",
        cMapPacked: true,
    };
    var pdfProps = {
        pdfSource: pdfSource,
        options: documentOptions,
        faxId: faxId,
        faxDocument: faxDocument,
        faxDocumentType: faxDocumentType,
        showRotation: showRotation,
        editing: editing || false,
        enablePdfAction: enablePdfAction,
        handleCancel: handleCancel,
        handleShowEditor: handleShowEditor,
        fabricDataMapJSON: fabricDataMapJSON,
        onCreateDraft: onCreateDraft,
        validateInCharge: validateInCharge,
        updateInCharge: updateInCharge,
    };
    return react_1.default.createElement(AcPdf_1.AcPdf, __assign({}, pdfProps));
};
exports.AcDocumentViewer = AcDocumentViewer;
AcDocumentViewer.defaultProps = {
    multiPage: true,
    showRotation: false,
};
exports.default = AcDocumentViewer;
AcDocumentViewer.displayName = 'AcDocumentViewer';
//# sourceMappingURL=AcDocumentViewer.js.map